
  import ModelItems from '@/mixins/ModelItems';
  import {Language, LanguageLevel} from '@/model/Profile';
  import {sortArrays} from '@/helper/SortingHelper';

  export default {
    name: 'LanguageSubForm',
    mixins: [ModelItems],
    props: {
      language: {
        type: Object,
        required: true,
      },
      i: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        internalLanguage: {},
        rulesForValue: null,
        levelItems: this.prepareModelItems(LanguageLevel),
      };
    },
    computed: {
      sortedLanguageItems() {
        const specialLanguageItems = [
          'language.de',
          'language.en',
          'language.fr',
          'language.es',
          'language.tr',
        ];
        return sortArrays(
          this.prepareModelItems(specialLanguageItems),
          this.prepareModelItems(Language)
        );
      },
    },
    watch: {
      language: {
        deep: true,
        handler() {
          this.internalLanguage = this.language;
        },
      },
    },
    created() {
      this.internalLanguage = this.language;
    },
    methods: {
      updateGroupValidity(validate) {
        this.$emit('validate', validate);
      },
    },
  };
